import { ToggleButtonGroup, styled } from '@mui/material';

export const FilterToggleButtonGroup = styled(ToggleButtonGroup)({
  margin: '24px 16px',
  gap: 8,
  '& .MuiToggleButtonGroup-grouped': {
    fontSize: '12px',
    boxShadow: '0 0 0 1px rgba(6, 117, 221, 0.5)',
    border: '0px !important',
    borderRadius: '4px !important',
    margin: '0px !important',
    color: '#0259AB !important',
    padding: '6px 16px',
    '&:hover': {
      backgroundColor: 'transparent'
    },
    '&.Mui-selected, &.Mui-selected:hover': {
      backgroundColor: '#EBF3FA',
      boxShadow: 'none',
      paddingLeft: 10
    }
  }
});
